// Shows a list of (removable) recipients.
import { css } from '@emotion/react'
// Shows Add Contact at the end of this list to start Editing.
// Renders the RecipientSearch (in list mode) after you start Editing.
import React from 'react'
import cn from 'classnames'

import { emptyArr } from 'util/arrays'
import { propFunc, fanout } from 'util/functions'

import List from '../List'
import RecipientSearch from '../RecipientSearch'
import withEditMode from '../withEditMode'

// HACK (jscheel): This is ghetto and shameful, but we are out of time for launch
// and this needs to be working.
const onRemove = (
  doRemoveDraftRecipients,
  ticketId,
  type,
  afterRemove,
  onUpdate,
  recipients,
  index
) => {
  if (onUpdate) {
    if (recipients) {
      const newRecipients = [].concat(recipients)
      newRecipients.splice(index, 1)
      onUpdate(newRecipients)
    }
  } else {
    doRemoveDraftRecipients(ticketId, { [type]: recipients[index] })
  }
  if (afterRemove) {
    afterRemove()
  }
}
// END HACK

const RecipientsEditor = ({
  allowMultipleRecipients,
  continueEditing,
  doRemoveDraftRecipients,
  editing,
  error,
  forNote,
  forwardRef,
  isForwarding,
  maybeStopEditing,
  noAutoFocus,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  recipients = emptyArr,
  recipientsOpenUpward,
  saveOnTab,
  saveOnBlur = true,
  skipOnAdd,
  startEditing,
  stopEditing,
  sui,
  ticketId,
  toType = 'name',
  type,
  onUpdate,
  unspacedStyle,
}) => {
  const handleOnBlur = propFunc(fanout, maybeStopEditing, onBlur)
  const handleOnFocus = propFunc(fanout, continueEditing, onFocus)

  if (sui && !allowMultipleRecipients) {
    const recipient = recipients[recipients.length - 1]

    return (
      <RecipientSearch
        allowMultipleRecipients={false}
        defaultValue={recipient && recipient[toType]}
        continueEditing={continueEditing}
        editing={editing}
        error={error}
        forNote={forNote}
        forwardRef={forwardRef}
        noAutoClear
        noAutoFocus={noAutoFocus}
        onBlur={handleOnBlur}
        onChange={onChange}
        onFocus={handleOnFocus}
        onUpdateCustom={onUpdate}
        placeholder={placeholder}
        recipients={recipients}
        saveOnBlur={false}
        saveOnTab={saveOnTab}
        skipOnAdd={skipOnAdd}
        sui
        ticketId={ticketId}
        type={type}
        upward={recipientsOpenUpward}
        unspacedStyle={unspacedStyle}
      />
    )
  }

  if (!sui && !editing) {
    return (
      <List
        allowMultipleRecipients={allowMultipleRecipients}
        onRemove={propFunc(
          onRemove,
          doRemoveDraftRecipients,
          ticketId,
          type,
          !allowMultipleRecipients ? startEditing : null,
          onUpdate,
          recipients
        )}
        recipients={recipients}
        startEditing={startEditing}
        sui={sui}
        type={type}
        unspacedStyle={unspacedStyle}
      />
    )
  }

  return (
    <RecipientSearch
      afterToAdd={!allowMultipleRecipients ? stopEditing : null}
      allowMultipleRecipients={allowMultipleRecipients}
      editing={editing}
      isForwarding={isForwarding}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      onUpdateCustom={onUpdate}
      placeholder={placeholder}
      recipients={recipients}
      saveOnBlur={saveOnBlur}
      saveOnTab={saveOnTab}
      skipOnAdd={skipOnAdd}
      sui={sui}
      ticketId={ticketId}
      type={type}
      upward={recipientsOpenUpward}
      unspacedStyle={unspacedStyle}
    />
  )
}

const Container = ({ className, ...rest }) => {
  const { ticketId } = rest
  return (
    <div
      className={cn('grui flex flex-auto', className)}
      css={css`
        width: 100%;
      `}
    >
      <RecipientsEditor key={`recipientseditor-header-${ticketId}`} {...rest} />
    </div>
  )
}

export default withEditMode(Container)
